import { WHATSAPP_CHAT_URL } from '../../../config/contactLinks';

const testimonials = [
  {
    name: 'Ayşe Kaya',
    role: 'Ev Sahibi — Villa Temizliği',
    comment: 'Villam her zamankinden çok daha temiz! NiğPak ekibi gerçekten profesyonel. Her detaya özen gösterdiler, köşeleri bile atlamadılar. Kesinlikle tavsiye ediyorum.',
    rating: 5,
    initial: 'A',
  },
  {
    name: 'Mehmet Arslan',
    role: 'İşyeri Sahibi — Mağaza Temizliği',
    comment: 'Mağazamız için aylık kontrat yaptık. Her ay düzenli geliyor, hiçbir sorun yaşamadık. Fiyat-kalite oranı mükemmel. Niğde\'de bu kadar kaliteli bir temizlik firması görmemiştim.',
    rating: 5,
    initial: 'M',
  },
  {
    name: 'Fatma Demir',
    role: 'Mülk Sahibi — Kiracı Sonrası',
    comment: 'Kiracım çıktıktan sonra dairem berbat durumdaydı. NiğPak ekibi adeta sihir gibi temizledi. Yeni kiracım daireye girince inanamamış! Harika bir iş çıkardılar.',
    rating: 5,
    initial: 'F',
  },
  {
    name: 'Ali Yılmaz',
    role: 'Restoran İşletmecisi — Restoran Temizliği',
    comment: 'Restoranımızın mutfak temizliğini NiğPak yapıyor. Hijyen standartlarına çok dikkat ediyorlar. Sağlık denetiminde tam puan aldık. Çok memnunuz!',
    rating: 5,
    initial: 'A',
  },
  {
    name: 'Zeynep Şahin',
    role: 'Ofis Müdürü — Ofis Temizliği',
    comment: 'Ofisimiz her sabah tertemiz. Çalışanlarımızın morali çok yüksek, temiz ortamda çok daha verimli çalışıyoruz. NiğPak\'ı kesinlikle tavsiye ediyorum.',
    rating: 5,
    initial: 'Z',
  },
  {
    name: 'Hasan Öztürk',
    role: 'Apartman Yöneticisi — Apartman Temizliği',
    comment: 'Apartmanımızın ortak alanlarını temizliyorlar. Saatinde geliyorlar, işlerini özenle yapıyorlar. Sakinlerin hepsi çok memnun. Uzun süredir çalışıyoruz.',
    rating: 5,
    initial: 'H',
  },
];

export default function Testimonials() {
  return (
    <section id="referanslar" className="py-24 bg-navy">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <p className="text-gold text-xs font-bold uppercase tracking-[0.25em] mb-3">Müşteri Yorumları</p>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">
              Referanslarımız
            </h2>
          </div>
          <div className="flex items-center gap-1.5">
            {[1,2,3,4,5].map(i => (
              <span key={i} className="w-5 h-5 flex items-center justify-center">
                <i className="ri-star-fill text-gold text-lg"></i>
              </span>
            ))}
            <span className="text-white/60 text-sm ml-2">500+ Değerlendirme</span>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div key={t.name}
              className="bg-white/5 border border-white/10 rounded-xl p-6 hover:border-gold/40 hover:bg-white/[0.07] transition-all">
              {/* Stars */}
              <div className="flex items-center gap-1 mb-5">
                {[...Array(t.rating)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-gold text-sm"></i>
                  </span>
                ))}
              </div>
              {/* Quote */}
              <p className="text-white/80 text-sm leading-[1.8] mb-6">
                &ldquo;{t.comment}&rdquo;
              </p>
              {/* Author */}
              <div className="flex items-center gap-3 pt-5 border-t border-white/10">
                <div className="w-10 h-10 flex items-center justify-center bg-gold rounded-lg shrink-0 text-white font-extrabold text-sm">
                  {t.initial}
                </div>
                <div>
                  <p className="text-white font-bold text-sm leading-none">{t.name}</p>
                  <p className="text-white/40 text-xs mt-1">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-6 border-t border-white/10 pt-10">
          <p className="text-white/60 text-sm">Siz de NiğPak Temizlik ailesine katılın.</p>
          <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
            className="flex items-center gap-2 bg-gold hover:bg-gold-dark text-white font-bold px-6 py-3 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-whatsapp-line text-base"></i>
            Teklif İçin Yazın
          </a>
        </div>
      </div>
    </section>
  );
}
